import { render, staticRenderFns } from "./PillStatus.vue?vue&type=template&id=9446cf50&scoped=true&"
import script from "./PillStatus.vue?vue&type=script&lang=js&"
export * from "./PillStatus.vue?vue&type=script&lang=js&"
import style0 from "./PillStatus.vue?vue&type=style&index=0&id=9446cf50&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9446cf50",
  null
  
)

export default component.exports